export default "__VITE_ASSET__ad442072__"